import { Component, inject, OnInit, Signal, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { LookupList } from '../../../../../core/models/lookup-list.model';
import { LookupListService } from '../../../../../core/services/lookup-list.service';
import { TranslatePipe } from '../../../../../shared/pipes/translate.pipe';

/**
 * Formly field type for radio button group
 *
 * Props:
 * - label: string - Field label
 * - description: string - Helper text
 * - required: boolean - Whether selection is required
 * - options: Array<{value: any, label: string, description?: string, isDefault?: boolean}> - Radio options
 */
@Component({
  selector: 'app-radio-field',
  imports: [ReactiveFormsModule, FormlyModule, TranslatePipe],
  templateUrl: './radio-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './radio-field.component.css',
})
export class RadioFieldComponent extends FieldType<FieldTypeConfig> implements OnInit {
  private lookupListService = inject(LookupListService);
  private _lookupListSignal: Signal<LookupList | null> | null = null;

  ngOnInit(): void {
    const optionsSource = this.props['optionsSource'] as string | undefined;
    const lookupListId = this.props['lookupListId'] as string | undefined;
    if (optionsSource === 'lookup-list' && lookupListId) {
      const query = this.lookupListService.createQueryById(lookupListId);
      this._lookupListSignal = query.data;
    }
    // Apply default when the control has no value yet (new form interaction)
    if (this.formControl.value === null || this.formControl.value === undefined) {
      const defaultOpt = this.radioOptions.find((o) => o.isDefault);
      if (defaultOpt) {
        this.formControl.setValue(defaultOpt.value);
      }
    }
  }
  /**
   * Get options from props or from the linked lookup list
   */
  get radioOptions(): { value: any; label: string; description?: string; isDefault?: boolean }[] {
    if (this._lookupListSignal) {
      return this._lookupListSignal()?.options ?? [];
    }
    const opts = this.props['options'] as any;
    if (Array.isArray(opts)) {
      return opts;
    }
    return [];
  }
}
